import { useGlobalConfig } from '@/contexts/global-config-context';
import { useUserInfoContext } from '@/contexts/user-info-context';
import {
  getUserConfigFromTargetSpace,
  updateUserConfigFromTargetSpace,
} from '@/services/user';
import { useEffect, useState } from 'react';
import { Button } from 'antd';
import { Modal } from '../antd-wrapper/modal/global/modal';
import { useI18n } from '@/hooks/use-i18n';

const EVT_NAME = 'open-update-version-modal';

export const openUpdateVersionModal = () => {
  window.dispatchEvent(new CustomEvent(EVT_NAME));
};

const UpdateVersionModal = () => {
  const { t } = useI18n('auth');
  const { globalConfig } = useGlobalConfig();

  const spaceCreditPointsPersonPoints =
    globalConfig['space_credit_points_person']?.value?.points || 0;
  const spaceCreditPointsDayGrantPoints =
    globalConfig['space_credit_points_day_grant']?.value?.points || 0;

  const [open, setOpen] = useState(false);

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handleWorkerDetail = () => {
      setOpen(true);
    };

    // Add event listener
    window.addEventListener(EVT_NAME, handleWorkerDetail as EventListener);

    // Cleanup
    return () => {
      window.removeEventListener(EVT_NAME, handleWorkerDetail as EventListener);
    };
  }, []);

  const updateItem = [
    t('updateVersionModal.openToAll'),
    <span key="2">
      {t('updateVersionModal.pointsReward', {
        personPoints: spaceCreditPointsPersonPoints || 0,
        dayPoints: spaceCreditPointsDayGrantPoints || 0,
      })}
    </span>,
    t('updateVersionModal.teamVersion'),
    <span key="4">{t('updateVersionModal.unlockDataSources')}</span>,
    t('updateVersionModal.agentLimit'),
  ];
  return (
    <Modal
      title={t('updateVersionModal.title')}
      open={open}
      onOk={onClose}
      onCancel={onClose}
      closeButtonYOffset={-35}
      okText={t('updateVersionModal.gotIt')}
      cancelText=""
      width={600}
      height={'fit-content'}
      headerHeight={72}
      footer={[
        <Button key="ok" type="primary" className="mb-[24px]" onClick={onClose}>
          {t('updateVersionModal.gotIt')}
        </Button>,
      ]}
      className="[&_.ant-modal-content]:!p-0 [&_.ant-modal-header]:!h-[72px] [&_.ant-modal-header]:!bg-[#7171EE] [&_.ant-modal-header]:!text-center [&_.ant-modal-header]:!mb-0 [&_.ant-modal-title]:!text-[#fff] [&_.ant-modal-title]:!leading-[72px] [&_.ant-modal-body]:!p-[16px_24px] [&_.ant-modal-close-x]:!text-white"
    >
      <div className="text-[14px] leading-[22px]">
        {t('updateVersionModal.greeting')}
        <br />
        {t('updateVersionModal.announcement')}
        <div className="my-4 pl-4 bg-[#F8F8FA]">
          {updateItem.map((item, index) => (
            <div
              key={index}
              className="flex items-center py-4 pr-4 border-b border-dashed border-[#dfdfe1] last:border-b-0"
            >
              <span className="w-4 h-4 rounded-full inline-flex items-center justify-center bg-[#7171EE] text-[#fff] text-[10px] mr-3 shrink-0 leading-4">
                {index + 1}
              </span>
              <span className="flex-1">{item}</span>
            </div>
          ))}
        </div>
        {t('updateVersionModal.thanks')}
      </div>
    </Modal>
  );
};

export default UpdateVersionModal;
